module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_new_costume-0783b5b877e9c1f89924b5882423e4ae.jpg";